import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactInformation from "./sections/ContactInformation";
import ReservationForm from "./sections/ReservationForm";
import FAQ from "./sections/FAQ";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactInformation />
      <ReservationForm />
      <FAQ />
      <Footer />
    </div>;
}